import SingleProductHelper from './single-product-helper';

class SingleProduct {
    constructor() {
        // console.info('singleProduct.constructor()');

        this.helper = new SingleProductHelper();

        // lazy loader
        $('.lazy-product-tile').Lazy();

        // track product view in cookie
        window.cookieHelper.addProductView($('.product-main-wrapper').data('id'));

        this.sliderMainImage = $('.product-slider-main');
        this.sliderThumbImage = $('.thumbs-slider');
        this.expandToggle = $('.open-toggle');
        this.scentSelect = $('.js-scent-selector');
        this.wtbButton = $('.js-wtb-btn');

        this.$productDescription = $('.product-desc');
        this.defaultDescription = this.$productDescription.html();

        this.handleSlickSlideshow();
        this.handleImageExpanderListeners();
        SingleProduct.handleFAQs();
        this.handleMisc();
        // this.handleBV();
        this.handleWTB();
    }

    handleSlickSlideshow() {
        // console.info('singleProduct.handleSlickSlideshows()');

        // handle right-to-left language setting
        const rtl = $('body').hasClass('rtl');

        // slick slideshows
        $('.product-advice-list').slick({
            rtl,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: 'unslick',
                },
            ],
        });

        $('.recommended').slick({
            rtl,
            arrows: false,
            dots: true,
            mobileFirst: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 769,
                    settings: 'unslick',
                },
            ],
        });

        // product image slideshows
        this.sliderMainImage.slick({
            rtl,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            fade: true,
        });

        this.sliderThumbImage.slick({
            rtl,
            slidesToScroll: 4,
            arrows: true,
            infinite: false,
            focusOnSelect: false,
            prevArrow: '#thumb-prev',
            nextArrow: '#thumb-next',
        });

        // handle selecting a thumbnail
        this.sliderThumbImage.on('click', (event) => {
            if (event.target) {
                const $slide = $(event.target).closest('.slick-slide');

                if ($slide.length) {
                    this.sliderThumbImage.find('.slick-slide').removeClass('custom-slick-current');

                    $slide.addClass('custom-slick-current');

                    const index = $slide.index(this.sliderThumbImage.slick.$slides);

                    this.sliderMainImage.slick('slickGoTo', index);

                    // handle click on video or 360
                    const slick = this.sliderMainImage.slick('getSlick');
                    const $mainSlide = $(slick.$slides[index]);

                    if ($mainSlide.find('.js-image-over-video,.js-360-view').length) {
                        if (!$('.js-image-wrapper').hasClass('fullscreen')) {
                            // wait for main slider to complete update
                            this.sliderMainImage.one('afterChange', () => {
                                this.expandToggle.click();
                            });
                        }
                    }
                }
            }
        });

        // keep thumb slider in sync with main
        this.sliderMainImage.on('afterChange', (e, slick, currentSlide) => {
            const $slides = this.sliderThumbImage.find('.slick-slide').removeClass('custom-slick-current');
            $slides.eq(currentSlide).addClass('custom-slick-current');

            // can this image be expanded
            const $currentSlide = $(slick.$slides.get(currentSlide));
            const data = $currentSlide.data();
            let $showExpandButton = true;
            if (data && !data.expandable && !$('.js-image-wrapper').hasClass('fullscreen')) {
                $showExpandButton = false;
            }

            if ($showExpandButton) {
                $('.open-toggle').show();
            } else {
                $('.open-toggle').hide();
            }

            // init 360 in expanded mode
            if ($('.js-image-wrapper').hasClass('fullscreen')) {
                this.setup360();
            }
        });

        // video slide handler
        if (!!(window.OptanonActiveGroups && window.OptanonActiveGroups.indexOf('C0004') >= 0)) {
            this.sliderMainImage.on('click', '.js-image-over-video', (e) => {
                const $this = $(e.currentTarget);
                const $player = $this.parent().find('.video-player');
                const $iframe = $player.find('iframe');
                const vidid = $iframe.data('video-id');

                // add youtube url w/autoplay to iframe
                $iframe.attr('src', `//www.youtube.com/embed/${vidid}?enablejsapi=1&autoplay=1&rel=0`);
                $player.show();

                // hide image
                $this.hide();
            });
        } else {
            $('.consent-message').removeClass('hidden');
        }
    }

    handleMisc() {
        // console.info('singleProduct.handleMisc()');

        // event handlers
        // url, history, state handling
        // flag to prevent setting history state on restore from history
        let disableUpdateUrl = false;

        // update history event
        $('body').on('updateurl', (e, scent) => {
            // console.log('updateurl '+scent);
            if (disableUpdateUrl) return;

            const urlBase = translatedStrings.urls['/products/'];
            if (window.history.state) {
                window.history.pushState(
                    {
                        scent,
                    },
                    null,
                    `${urlBase + $('body').attr('id')}/${scent}/${window.location.search}`
                );
            } else {
                window.history.replaceState(
                    {
                        scent,
                    },
                    null,
                    `${urlBase + $('body').attr('id')}/${scent}/${window.location.search}`
                );
            }
        });

        // restore from history event
        $(window).on('popstate', () => {
            disableUpdateUrl = true;

            const { state } = window.history;
            if (state && state.scent) {
                // console.log('popstate: '+state.scent);
                const orig = this.scentSelect.val();
                this.scentSelect.val(state.scent);
                // check for bad scent
                if (!this.scentSelect.val()) {
                    this.scentSelect.val(orig);
                } else {
                    this.scentSelect.trigger('change');
                }
            }

            disableUpdateUrl = false;
        });

        // scent selector
        this.scentSelect.on('change', () => {
            const data = this.scentSelect.find(':selected').data();
            this.selectScent(data);
        });

        // initial setup
        if (window.location.hash) {
            const hashValue = window.location.hash.substr(1);
            if (hashValue === 'instructions') {
                // give time to allow image slideshows
                setTimeout(this.handleInstructionsHash(), 100);
            }
        }

        // check for last segment of url (scent)
        const parts = window.location.pathname.split('/');
        if (parts.length >= 5) {
            // 2nd to last is scent (last is '')
            const urlScent = parts[parts.length - 2];
            const orig = this.scentSelect.val();
            this.scentSelect.val(urlScent);
            // check for bad scent
            if (!this.scentSelect.val()) {
                this.scentSelect.val(orig);
            }
        }

        this.selectScent(this.scentSelect.find(':selected').data(), true);

        // uses popup handling
        // setupImages(CLOROX_GLOBAL['scentImages'][scentData.scent]);
        // category.rooom.use
        const { useData } = CLOROX_GLOBAL;
        const iconPathRoot = $('.js-use-icon use').attr('xlink:href');

        /* eslint-disable no-use-before-define */
        const $useCategory = $('.js-use-category').on('change', () => {
            const value = $useCategory.val();
            // clear rooms
            $useRoom.children().remove();
            // reload rooms
            $useRoom.append(
                $('<option>', {
                    value: '',
                    text: defaultText,
                })
            );

            if (value && useData[value]) {
                $.each(useData[value].children, (room, item) => {
                    $useRoom.append(
                        $('<option>', {
                            value: room,
                            text: item.display,
                        })
                    );
                });
                $('.question-second').show();
            } else {
                $('.question-second').hide();
                $('.question-third').hide();
            }

            $useRoom.trigger('change');
        });
        const defaultText = $('option:first', $useCategory).text();
        const $useRoom = $('.js-use-room').on('change', () => {
            const value = $useRoom.val();
            // console.log('room change: '+value);
            // clear & load uses
            $useUse.children().remove();
            $useUse.append(
                $('<option>', {
                    value: '',
                    text: defaultText,
                })
            );
            if (value) {
                $.each(useData[$useCategory.val()].children[value].children, (use) => {
                    $useUse.append(
                        $('<option>', {
                            text: use,
                        })
                    );
                });
                $('.question-third').show();
            } else {
                $('.question-third').hide();
            }
            $useUse.trigger('change');
        });

        const $useUse = $('.js-use-use').on('change', () => {
            const value = $useUse.val();
            if (value) {
                const item = useData[$useCategory.val()].children[$useRoom.val()].children[value];
                // console.log('use change: '+value,item);
                // change use info
                $('.js-use-instructions').html(item.instructions);
                if (item.instruction_image) {
                    $('.js-use-image').attr('src', item.instruction_image).show();
                } else {
                    $('.js-use-image').hide();
                }
                if (item.instruction_icon) {
                    $('.js-use-icon use').attr('xlink:href', `${iconPathRoot}#${item.instruction_icon}`);
                    $('.js-use-icon').show();
                } else {
                    $('.js-use-icon').hide();
                }
                $('.js-use-disclaimer').html(item.disclaimer);
            } else {
                $('.js-use-instructions').html('');
                $('.js-use-image').attr('src', '').hide();
                $('.js-use-icon').hide();
                $('.js-use-disclaimer').html('');
            }
        });
        $useCategory.trigger('change');
    }

    // setup slider with scent images+
    setupImages(data) {
        // console.info('singleProduct.setupImages()');

        this.sliderMainImage.slick('slickRemove', null, null, true);
        this.sliderThumbImage.slick('slickRemove', null, null, true);

        // if only one image, no thumbnails needed
        if (data.length === 1) {
            this.sliderThumbImage.hide();
        } else {
            this.sliderThumbImage.show();
        }

        this.sliderThumbImage.slick('slickSetOption', 'slidesToShow', data.length <= 4 ? data.length : 4);
        if (data.length <= 4) {
            this.sliderThumbImage.parent().addClass('short-slider');
        } else {
            this.sliderThumbImage.parent().removeClass('short-slider');
        }

        $.each(data, (i, item) => {
            this.sliderThumbImage.slick('slickAdd', this.helper.renderThumbnailSlide(item));
            if (i === 0) {
                const yOffset = document.querySelector('.product-slider-main').getAttribute('data-vertical-image-offset') || 0;
                // eslint-disable-next-line
                item.yOffset = yOffset;
            }
            let html = '';
            switch (item.type) {
                case 'image':
                    html = this.helper.renderImageSlide(item);
                    break;
                case 'video':
                    html = this.helper.renderVideoSlide(item);
                    break;
                case '360':
                    // eslint-disable-next-line
                    item.image = item.spin_images[0];
                    html = this.helper.render360Slide($.extend(item, { cdn_path: CLOROX_GLOBAL.CDN_PATH }));
                    setTimeout(() => {
                        $('.js-360-view').data('item', item);
                        // defer 360 init till slide is expanded
                    }, 1); // nd time to render new html
                    break;
                default:
                    html = '<div>Media type not yet implemented</div>';
            }
            this.sliderMainImage.slick('slickAdd', html);
        });

        this.sliderMainImage.trigger('afterChange', [this.sliderMainImage.slick('getSlick'), 0]);
    }

    // call to setup 360 view on slide while in expanded view
    setup360() {
        // console.info('singleProduct.setup360()');

        // setup 360
        // initialize 360
        const $view = $('.js-360-view', this.sliderMainImage.find('.slick-active'));
        const item = $view.data('item');

        if (!item) {
            return;
        }

        $('.js-360-spinner').show();
        const $image = $view.find('.js-360-preview img');
        function init() {
            $view.ThreeSixty({
                images: item.spin_images,
                totalFrames: item.spin_images.length,
                imgList: '.js-360-images',
                progress: '.js-360-spinner',
                preview: '.js-360-preview',
                endFrame: 0,
                currentFrame: 18,
                navigation: false,
                drag: true,
                showCursor: true,
                interval: 40,
                speedMultiplier: 7,
                disableSpin: true,
                height: 0,
                width: $image.width(),
                onReady() {
                    $view.removeClass('threesixty-loading');
                    // prevent dragging when image not expanded
                    $view.find('img').on('mousedown touchstart touchmove touchend mousemove click', (event) => {
                        if (!$('.js-image-wrapper').hasClass('fullscreen')) {
                            event.preventDefault();
                            return false;
                        }
                        return null;
                    });
                    $view.find('img').on('mousedown touchstart', () => {
                        $('.js-spin-360-drag-message').fadeOut(1000);
                    });
                    $('.js-spin-360-drag-message').fadeIn();
                },
            });

            $view.data('item', false);
        }

        if ($image[0].complete) {
            // image has already loaded
            init();
        } else {
            // wait for image to load
            $image.one('load', () => {
                init();
            });
        }
    }

    // setup shopping buttons on scent change
    changeUpcs(upc, upcs) {
        // console.info('singleProduct.changeUpc()');

        let upcString = '';
        if (upc) {
            upcString = upc.toString();
        }
        if (upcs) {
            upcString += `, ${upcs}`;
        }

        if (this.wtbButton.data('method') === 'mikmak' && window.swnDataLayer) {
            // set mikmak where to buy upcs
            this.wtbButton[0].setAttribute('data-eans', upcString);
            // view_page rechecks page in case initial scent didn't have upcs
            // picks up new values
            window.swnDataLayer.push({event: 'view_page'})
        }
    }

    handleWTB() {
        const method = this.wtbButton.data('method');
        this.wtbButton.on('click', (e) => {
            const eans = this.wtbButton[0].getAttribute('data-eans');
            if (method === 'mikmak' && eans) {
                // use mikmak
                return;
            }

            // prevent mikmak
            e.stopImmediatePropagation();

            // use standard wtb modal
            $('#wtb-modal').modal('show');
        });
    }

    // called on scent change
    selectScent(scentData, skipName) {
        // console.info('singleProduct.selectScent()', scentData);

        if (!skipName) {
            $('.js-product-title').html(scentData.title);
        }
        $('.scent-indicator').css('background', scentData.color);
        $('.product-ingredients a').attr('href', scentData.ingredientsurl);
        SingleProduct.setGradient(scentData.color);
        this.setupImages(CLOROX_GLOBAL.scentImages[scentData.scent]);
        this.changeUpcs(scentData.upc, scentData.upcs);

        // allow scents to hide covid badge
        $('.js-covid-badge').toggle(!scentData.hideCovid);

        // scents can  now override product desc
        if (CLOROX_GLOBAL.scentDescription[scentData.scent]) {
            this.$productDescription.html(CLOROX_GLOBAL.scentDescription[scentData.scent]);
        } else {
            this.$productDescription.html(this.defaultDescription);
        }

        // handle wtb changes
        if (scentData.channelAdvisorId) {
            let url = `https://where-to-buy.co/widgets/core/BuyOnlineBuyLocalV2/index.html?pid=12010807&model=${scentData.channelAdvisorId}`;
            if (CLOROX_GLOBAL.language && CLOROX_GLOBAL.language !== 'en') {
                url += `&lang=${CLOROX_GLOBAL.language}`;
            }
            $('.js-wtb-product').hide();
            $('.js-wtb-scent iframe').attr('src', url);
            $('.js-wtb-scent').show();
            $('.js-buy-button').show();
        } else {
            // use product level wtb info
            $('.js-wtb-scent').hide();
            $('.js-wtb-product').show();

            // hide button if there is no scent or product wtb info
            if ($('.js-contentblock-default-content').text().trim().length) {
                $('.js-buy-button').show();
            } else {
                $('.js-buy-button').hide();
            }
        }

        // set url based on scent
        $('body').trigger('updateurl', [scentData.scent]);
    }

    // set gradient behind image slider
    static setGradient(color) {
        // console.info('singleProduct.setGradient()');

        $('.js-gradient').css(
            'background',
            `${
                color /* Old browsers */
            } linear-gradient(135deg, ${color}, #ffffff)` /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        );
    }

    static handleFAQs() {
        // console.info('singleProduct.handleFAQs()');

        // faqs
        const $faqItems = $('.js-faq-item');
        const $catSelect = $('.js-faq-category-select').on('change', () => {
            const index = $catSelect.prop('selectedIndex');
            $faqItems.hide();
            $faqItems.filter(`.js-faq-cat-${index}`).show();
        });

        $faqItems.on('click', function faqClick() {
            const $this = $(this);
            $('.toggle span', $this).toggle();
            $('.answer', $this).slideToggle();
        });
    }

    // #instructions is used to show video on clean-up-cleaner-bleach
    //  find first video in media list & embiggen it
    handleInstructionsHash() {
        // console.info('singleProduct.handleInstructionsHash()');

        const data = this.scentSelect.find(':selected').data();
        const media = CLOROX_GLOBAL.scentImages[data.scent];

        for (let i = 0; i < media.length; i += 1) {
            const item = media[i];
            if (item.type === 'video') {
                // click on 1st video & end special handling
                this.sliderThumbImage.slick('getSlick').$slides[i].click();
                return;
            }
        }
    }

    handleImageExpanderListeners() {
        // console.info('singleProduct.handleImageExpanderListeners()');

        const openFunction = () => {
            if (!$('.js-image-wrapper').hasClass('fullscreen')) {
                // expanding
                // remove non-highres images
                this.sliderThumbImage.slick('slickFilter', '[data-expandable=true]');
                this.sliderMainImage.slick('slickFilter', '[data-expandable=true]');
                this.setup360();
            } else {
                // contracting
                this.sliderThumbImage.slick('slickUnfilter');
                this.sliderMainImage.slick('slickUnfilter');
            }

            // make fullscreen
            $('.js-image-wrapper').toggleClass('fullscreen');

            // adjustments for missing slides
            const { slideCount } = this.sliderThumbImage.slick('getSlick');
            this.sliderThumbImage.slick('slickSetOption', 'slidesToShow', slideCount <= 4 ? slideCount : 4);
            if (slideCount <= 4) {
                this.sliderThumbImage.parent().addClass('short-slider');
            } else {
                this.sliderThumbImage.parent().removeClass('short-slider');
            }

            // select proper slide - index needs to change
            const index = $('.custom-slick-current').index(this.sliderThumbImage.slick.$slides);
            this.sliderMainImage.slick('slickGoTo', index);

            // cleanup positioning for sliders
            this.sliderThumbImage.slick('reinit'); // fix for buttons after filter change
            this.sliderMainImage.slick('setPosition');
            this.sliderThumbImage.slick('setPosition');
        };
        // image expander
        this.expandToggle.on('click', openFunction);
        // image expander on press enter
        this.expandToggle.on('keypress', (e) => e.key === 'Enter' && openFunction());

        // close on esc
        document.documentElement.addEventListener('keydown', (e) => {
            if ($('.js-image-wrapper').hasClass('fullscreen') && e.key === 'Escape') {
                $('.open-toggle').trigger('click');
            }
        });
    }
}
// eslint-disable-next-line no-new
new SingleProduct();
